export function checkRoles(user, roles) {
  return user && user.role ? roles.includes(user.role) : false;
}
export function checkRolesByOrganizationProject(user, projectId, roles) {
  return user && user.usersProjectsWithRoles[`${projectId}`] ? roles.includes(user.usersProjectsWithRoles[`${projectId}`]) : false;
}
export function checkRolesByOrganization(user, organizationId, roles) {
  return user && user.organizationsRoles && user.organizationsRoles[`${organizationId}`] ? roles.includes(user.organizationsRoles[`${organizationId}`]) : false;
}
export function accessSettings(user) {
  return user && user.accessSettings ? user.accessSettings : false;
}